import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EnrichedMessage } from '@app/views/components/email/email.service';

@Component({
    selector: 'tt-email-person-info-dialog',
    templateUrl: './email-person-info-dialog.component.html',
    styleUrls: ['./email-person-info-dialog.component.css'],
})
export class EmailPersonInfoDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: { email: EnrichedMessage }, public dialogRef: MatDialogRef<EmailPersonInfoDialogComponent>) {}
}
